import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "button"]

  connect() {
    this.onKeydown = this.onKeydown.bind(this)
    this.enabled = false
    document.addEventListener("keydown", this.onKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKeydown)
  }

  onKeydown(e) {
    if (e.key === "Escape") {
      this.reset()
      return
    }
    if (e.metaKey || e.ctrlKey || e.altKey) return
    if (!this.hasInputTarget) return
    if (document.activeElement === this.inputTarget) return

    if (e.key.toLowerCase() === "t") {
      e.preventDefault()
      if (this.enabled) {
        this.reset()
      } else {
        this.enable()
      }
    }
  }

  enable() {
    this.enabled = true
    this.buttonTarget.classList.add("hidden")
    this.inputTarget.classList.remove("hidden")
    this.inputTarget.focus()
  }

  filter() {
    const query = this.inputTarget.value.toLowerCase().trim()
    const grid = document.querySelector(".partner-grid")
    const items = [...grid.children]
    items.forEach(item => {
      const card = item.querySelector(".partner-card") || item
      const name = (card.dataset.name || "").toLowerCase()
      item.style.display = name.includes(query) ? "" : "none"
    })
  }

  reset() {
    this.enabled = false
    this.inputTarget.value = ""
    this.inputTarget.classList.add("hidden")
    this.buttonTarget.classList.remove("hidden")
    this.filter()
  }
}
